/** webchat */
import { ref, Ref } from 'vue'
import Store, {
  setApiKey,
  setCurrentPage,
  setEmail,
  setUser,
  setName
} from '@/store'
import { getUser } from '@/helpers/tokenStorage'


interface IframeControl {
  toogleIframe: Ref<boolean>;

  updateCoreValuesOnStore (): void;

  notifyOpen (): void;

  notifyClose (): void;
}


const toogleIframe = ref<boolean>(false)

export default function useIframeControl (): IframeControl {
  function updateCoreValuesOnStore (): void {
    const cacheUser = getUser()

    if (process.env.NODE_ENV === 'production') {

      const query = new URLSearchParams(window.location.search)
      const apiKey = query.get('api_key') ?? query.get('apiKey') ?? ''
      const page = query.get('page') ?? ''
      const user = cacheUser ?? query.get('user') ?? ''

      setApiKey(apiKey)
      setCurrentPage(page)
      setUser(user)

      // CUSTOM FIELDS
      const clientName = query.get('client_name') ?? query.get('clientName') ?? ''
      if (clientName && clientName !== 'null') setName(clientName)

      const clientEmail = query.get('client_email') ?? query.get('clientEmail') ?? ''
      if (clientEmail && clientEmail !== 'null') setEmail(clientEmail)
      // SET CACHE
      return
    }
    // SET CACHE

    // const user = cacheUser ?? '123123123123123'


    setCurrentPage('http://localhost:8081/webchat')
    setApiKey(process.env.VUE_APP_WEB_CHAT_API_KEY)
    // setUser(user)

    /**
     * If exists a query param named 'name' and 'email', the widget will
     * use this values to prefill the name and email fields.
     */
    // setName('Teste')
    // setEmail('testes@gmail.com')
  }

  function notifyOpen (): void {
    toogleIframe.value = true
    window.parent.postMessage({
      isWidget: true,
      isOpen: true,
      step: Store.currentComponent
    }, '*')
  }

  function notifyClose (): void {
    toogleIframe.value = false
    window.parent.postMessage({
      isWidget: true,
      isOpen: false
    }, '*')
  }

  return {
    toogleIframe,
    updateCoreValuesOnStore,
    notifyClose,
    notifyOpen
  }
}
